import React from 'react';
import { Text } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { colors } from '@styleseat/brand';
import { IRootDispatch, RootState } from '../../../store/models';
import { PrivilegedProvider } from '../../../api/Providers';
import { IAbstractOnboardingCarouselCard, ISelfManagedOnboardingCarouselCard } from '../OnboardingCarousel/OnboardingCarousel.types';
import {
  ELITE_ONBOARDING_STATE_KEY,
  EliteOnboardingState,
  markEliteOnboardingComplete,
  openSchedulingWebsite,
} from './utils';

const Punch: React.FC = ({ children }) => (
  <Text style={{ color: colors.punch }}>{children}</Text>
);

export const EliteOnboardingCardKey = 'elite_onboarding';

export function checkExpireEliteOnboardingCard(
  dispatch: IRootDispatch,
  card: IAbstractOnboardingCarouselCard,
  provider: PrivilegedProvider,
): boolean {
  if (card.key === EliteOnboardingCardKey && !card.complete) {
    const joinedTime = moment(provider.joined_time, 'YYYY-MM-DDTHH:mm:ss');
    if (moment().diff(joinedTime, 'days') >= 7) {
      markEliteOnboardingComplete(dispatch, 'expired');
      return true;
    }
  }
  return false;
}

type EliteOnboardingCardInfo = {
  isLoaded: boolean;
  card: ISelfManagedOnboardingCarouselCard;
};

export function useEliteOnboardingCard(): EliteOnboardingCardInfo {
  const isUserStateLoaded = useSelector<RootState, boolean>(
    state => state.userState.loaded,
  );
  const eliteOnboardingState = useSelector<RootState, EliteOnboardingState>(
    state => state.userState.values?.[ELITE_ONBOARDING_STATE_KEY],
  ) || {};

  const dispatch = useDispatch<IRootDispatch>();
  return {
    isLoaded: isUserStateLoaded,
    card: {
      key: EliteOnboardingCardKey,
      title: <React.Fragment><Punch>Free</Punch> Elite Onboarding</React.Fragment>,
      body: 'Book with our specialists to help you meet your goals',
      cta: 'Schedule now',
      backgroundColor: colors.itsOff,
      onClick: () => {
        openSchedulingWebsite();
        markEliteOnboardingComplete(dispatch, 'scheduled');
      },
      onDismiss: () => {
        markEliteOnboardingComplete(dispatch, 'dismissed');
      },
      complete: !!eliteOnboardingState.completedReason,
    },
  };
}
